
import { Component, Mixins, Watch } from 'vue-property-decorator';
import ResponsivenessMixin from '@/features/common/mixins/responsivenessMixin';
import { NotificationMixin } from '../mixins';

@Component
export default class Packages extends Mixins(NotificationMixin, ResponsivenessMixin) {
  private formData = {
    isMinRequirement: {
      show: true,
      name: 'MinimumPackaging',
    },
    isInsuranceLimitation: {
      show: true,
      name: 'InsuranceLimitations',
    },
    isMissingPackageDimension: {
      show: true,
      name: 'DimensionsMissing',
    },
    isCarrierEnvelope: {
      show: true,
      name: 'CarrierEnv',
    },
    isCarrierPak: {
      show: true,
      name: 'CarrierPak',
    },
    isRiskOfOverLimit: {
      show: true,
      name: 'RiskOfOverLimit',
    },
    isRiskLargePackage: {
      show: true,
      name: 'RiskOfLargePackage',
    },
    isFreightRequirements: {
      show: true,
      name: 'FreightRequirements',
    },
  }

  get isTablet(): boolean {
    return this.$vuetify.breakpoint.lgAndDown;
  }

  @Watch('isNotificationPrefs', { immediate: true })
  private populatePreferences(newValue: boolean) {
    if (newValue) {
      this.formData.isMinRequirement.show = this.searchNotificationPref(
        this.formData.isMinRequirement.name,
      );
      this.formData.isInsuranceLimitation.show = this.searchNotificationPref(
        this.formData.isInsuranceLimitation.name,
      );
      this.formData.isFreightRequirements.show = this.searchNotificationPref(
        this.formData.isFreightRequirements.name,
      );
      this.formData.isMissingPackageDimension.show = this.searchNotificationPref(
        this.formData.isMissingPackageDimension.name,
      );
      this.formData.isCarrierEnvelope.show = this.searchNotificationPref(
        this.formData.isCarrierEnvelope.name,
      );
      this.formData.isCarrierPak.show = this.searchNotificationPref(
        this.formData.isCarrierPak.name,
      );
      this.formData.isRiskOfOverLimit.show = this.searchNotificationPref(
        this.formData.isRiskOfOverLimit.name,
      );
      this.formData.isRiskLargePackage.show = this.searchNotificationPref(
        this.formData.isRiskLargePackage.name,
      );
    }
  }
}
